export default {
      id: "ic_tribun_orange-usage",
      viewBox: "0 0 20 12",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_orange-usage",
      toString: function () {
        return this.url;
      }
    }